import { useState, useEffect, useMemo } from "react";
import { useFetchUser } from "../hooks/fetch/useFetchUsers";
import useStore from "../hooks/useStore";

const PeriodOverride = ({ id, disabled, value, onChange }) => {
  console.log("🎯 [periodOverride.jsx] Component rendered with:", {
    value,
    valueType: typeof value,
    userId: value?.userId,
    periodInit: value?.value,
  });

  const { value: periodInit, userId } = value || {};
  const [periodOverrideValue, setPeriodOverrideValue] = useState(periodInit);
  const clientRef = useStore((state) => state.clientRef);

  const { data: user, isLoading: isUserLoading } = useFetchUser({
    account: clientRef,
    userId,
  });

  console.log("🎯 [periodOverride.jsx] User data:", {
    userId,
    account: clientRef,
    isLoading: isUserLoading,
    hasUser: !!user,
    absenceUnit: user?.absenceSummary?.absenceUnit,
  });

  // Update local state when prop changes
  useEffect(() => {
    console.log(
      "🔄 [periodOverride.jsx] useEffect triggered - periodInit changed:",
      {
        oldValue: periodOverrideValue,
        newValue: periodInit,
      }
    );
    setPeriodOverrideValue(periodInit);
  }, [periodInit]);

  // Log when userId changes
  useEffect(() => {
    console.log("🔄 [periodOverride.jsx] userId changed:", {
      newUserId: userId,
      user: user,
      absenceUnit: user?.absenceSummary?.absenceUnit,
    });
  }, [userId, user]);

  const doChangePeriodOverride = (e) => {
    setPeriodOverrideValue(e.target.value);
    if (onChange) onChange(e.target.value);
  };

  // Use useMemo to recalculate label when user data changes
  const { daysHours, label } = useMemo(() => {
    const daysHours =
      user?.absenceSummary?.absenceUnit === "hours" ? "hours" : "days";
    const label = `Allocate specific number of ${daysHours} to this absence`;
    console.log("🏷️ [periodOverride.jsx] Label recalculated:", {
      daysHours,
      label,
      absenceUnit: user?.absenceSummary?.absenceUnit,
    });
    return { daysHours, label };
  }, [user?.absenceSummary?.absenceUnit]);

  return (
    <>
      <label htmlFor={id}>{label}</label>
      <input
        id={id}
        type="number"
        min="0"
        step={0.1}
        disabled={disabled}
        value={periodOverrideValue}
        onChange={doChangePeriodOverride}
      />
    </>
  );
};

export default PeriodOverride;
